import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NumberFormat from 'react-number-format';
import Select from "react-select";
import Dropzone from "react-dropzone";

class FormCreate extends Component {

    constructor(props) {
        super(props)
    }

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered modal-lg" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {this.props.title}</ModalHeader>

                    <form onSubmit={this.handleSubmit}>
                        <ModalBody>
                            <div className="row">

                                <div className="col-md-6 mb-3">
                                    <label>Nombre</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={this.props.formValues.name}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control ${!this.props.errorValues && this.props.formValues.name == "" ? "error-class" : ""}`}
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label>Fecha de creación</label>
                                    <input
                                        type="date"
                                        name="creation_date"
                                        value={this.props.formValues.creation_date}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control ${!this.props.errorValues && this.props.formValues.creation_date == "" ? "error-class" : ""}`}
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label>Fecha de vencimiento</label>
                                    <input
                                        type="date"
                                        name="due_date"
                                        value={this.props.formValues.due_date}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control ${!this.props.errorValues && this.props.formValues.due_date == "" ? "error-class" : ""}`}
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label>Emisor</label>
                                    <input
                                        type="text"
                                        name="emisor"
                                        value={this.props.formValues.emisor}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control`}
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <input
                                        type="hidden"
                                        name="responsable_user_id"
                                        value={this.props.selectedOptionUser.responsable_user_id}
                                    />
                                    <label>Responsable </label>
                                    <Select
                                        onChange={this.props.handleChangeAutocompleteUser}
                                        options={this.props.users}
                                        autoFocus={false}
                                        className={`link-form ${!this.props.errorValues && this.props.formValues.responsable_user_id == "" ? "error-class" : ""}`}
                                        value={this.props.selectedOptionUser}
                                    />
                                </div>

                                {true && (
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="hidden"
                                            name="proceso_id"
                                            value={this.props.selectedOptionProceso.proceso_id}
                                        />
                                        <label>Proceso </label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteProceso}
                                            options={this.props.procesos}
                                            autoFocus={false}
                                            className={`link-form ${!this.props.errorValues && this.props.formValues.proceso_id == "" ? "error-class" : ""}`}
                                            value={this.props.selectedOptionProceso}
                                        />
                                    </div>  
                                )}


                                <div className="col-md-12 mb-3">
                                    <label>Cargos que pueden acceder </label>
                                    <input
                                        type="hidden"
                                        name="position_ids"
                                        value={this.props.selectedOptionMulti.position_ids}
                                    />

                                    <Select
                                        onChange={this.props.handleChangeAutocompleteMulti}
                                        options={this.props.positions}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        autoFocus={false}
                                        className={`link-form`}
                                        classNamePrefix="select"
                                        name="position_ids"
                                        defaultValue={[
                                            this.props.editValues[0],
                                            this.props.editValues[1],
                                            this.props.editValues[2],
                                            this.props.editValues[3],
                                            this.props.editValues[4],
                                            this.props.editValues[5]
                                        ]}
                                    />
                                </div>

                    
                                <div className="col-md-12">
                                    <hr />
                                </div>

                                {true && (
                                    <div className="col-md-12">
                                        <Dropzone onDrop={(files) => this.props.handleChangeFile(files)}>
                                            {({ getRootProps, getInputProps }) => (
                                                <div
                                                    {...getRootProps({
                                                        className: 'dropzone',
                                                    })}
                                                >
                                                    <input {...getInputProps()} />
                                                    <p>{`${(this.props.nameFile != "" ? this.props.nameFile : "Arrastre y suelte el archivo aquí, o haga clic para seleccionar el archivo")}`}</p>
                                                </div>
                                            )}
                                        </Dropzone>
                                    </div>
                                )}

                                {!this.props.errorValues && (
                                    <div className="col-md-12 mt-4">
                                        <div className="alert alert-danger" role="alert">
                                            <b>Debes de completar todos los campos requeridos</b>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <label className="btn btn-light mt-2" onClick={() => this.props.toggle()}>Cerrar</label>
                            <button className="btn-shadow btn btn-info"
                                onClick={this.props.submitForm}
                                disabled={this.props.isLoaded}
                                style={{ color: "#ffff" }}
                            >
                                {this.props.isLoaded ? "Cargando.." : this.props.nameBnt}
                            </button>
                        </ModalFooter>
                    </form>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormCreate;